export default {
  accepted: {
    title: 'Chữ ký đã được chấp nhận',
    description: 'Chữ ký đã được chấp nhận. Cảm ơn bạn đã sử dụng dịch vụ giao hàng của chúng tôi!',
  },
  info: 'Bạn có một đơn giao hàng từ',
  title: 'Vui lòng xác nhận thông tin của bạn:',
  fields: {
    name: 'Tên người nhận:',
    phone: 'Số điện thoại người nhận:',
    address: 'Địa chỉ người nhận:',
    'rx-number': 'Số Rx:',
  },
  'action-btn': 'Gửi',
  'empty-signature': 'Vui lòng ký tên trước khi gửi.',
}
